import Icon from '../components/Icon.vue'

Icon.register({"terminal":{"width":1664,"height":1792,"paths":[{"d":"M585 983l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23zM1664 1440v64q0 14-9 23t-23 9h-960q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h960q14 0 23 9t9 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/terminal.js
// module id = 940
// module chunks = 0